import axios from '@/plugins/axios'
import customErrors from '@/store/error'
import {
  SPEND_TYPE,
  CLICKS_TYPE,
  IMPRESSIONS_TYPE,
  RATES_TYPE,
  CREATIVE_CLICKS_TYPE,
  CPM_TYPE,
  CTR_TYPE,
  REACH_TYPE,
  CITY_TYPE,
  DEVICE_TYPE,
  CAMPAIGNS_TYPE,
  PLACEMENTS_TYPE,
  CITY_PLACEMENTS_TYPE,
  DEVICE_PLACEMENTS_TYPE,
} from '@/helpers/pages/dashboard'
import {defaultKeysToFormat, formatKeyValues} from '@/helpers/formatCurrencyValues'

/**
 * Маппинг типов данных на соответствующие URL эндпоинты
 * @type {Object.<string, string>}
 */
const TYPE_TO_URL_MAP = {
  [SPEND_TYPE]: 'statistic/dashboard/spend',
  [IMPRESSIONS_TYPE]: 'statistic/dashboard/impressions',
  [CLICKS_TYPE]: 'statistic/dashboard/clicks',
  [CPM_TYPE]: 'statistic/dashboard/cpm',
  [CTR_TYPE]: 'statistic/dashboard/ctr',
  [REACH_TYPE]: 'statistic/dashboard/reach',
  [RATES_TYPE]: 'statistic/dashboard/quality-rate',
  [CREATIVE_CLICKS_TYPE]: 'statistic/dashboard/creative-type-clicks',
  [CITY_TYPE]: 'statistic/dashboard/city',
  [DEVICE_TYPE]: 'statistic/dashboard/device',
  [CAMPAIGNS_TYPE]: 'statistic/dashboard/campaigns',
  [PLACEMENTS_TYPE]: 'statistic/dashboard/placements',
  [CITY_PLACEMENTS_TYPE]: 'statistic/dashboard/city-impressions',
  [DEVICE_PLACEMENTS_TYPE]: 'statistic/dashboard/device-impressions',
}

const state = () => ({
  reach: {},
  spend: {},
  clicks: {},
  impressions: {},
  rates: {},
  creativeClicks: {},
  cpm: {},
  ctr: {},
  city: {},
  device: {},
  campaigns: {},
  placements: {},
  cityPlacements: {},
  deviceImpressions: {},
})

const getters = {
  permission: (state, getters, rootState) => ({
    readAll: rootState.auth?.permissions?.some((a) => a === 'DASHBOARD_READ_ALL'),
  }),
}

const mutations = {
  SET_CHART_DATA(state, {data, type}) {
    if (type === CITY_PLACEMENTS_TYPE) {
      state.cityPlacements = data
    } else if (type === DEVICE_PLACEMENTS_TYPE) {
      state.deviceImpressions = data
    } else {
      state[type] = data
    }
  },
}

const actions = {
  async GET_CHART_DATA({commit, dispatch}, {params, type}) {
    try {
      const url = TYPE_TO_URL_MAP[type]

      if (!url) {
        console.error(`Неизвестный тип данных: ${type}`)
        return
      }

      const {data} = await axios.get(url, {params})

      let processedData = data
      if ([CAMPAIGNS_TYPE].includes(type)) {
        processedData = formatKeyValues(data, defaultKeysToFormat)
      } else if ([PLACEMENTS_TYPE].includes(type)) {
        processedData = formatKeyValues(data, defaultKeysToFormat, false)
      }

      commit('SET_CHART_DATA', {data: processedData, type})
    } catch (err) {
      commit('SET_CHART_DATA', {data: {}, type})
      await customErrors(err, dispatch)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
